/**
 * return null on error
 */
export const decodeAudioBuffer = async (
  audioArrayBuffer: ArrayBuffer,
): Promise<AudioBuffer | null> => {
  const audioContext = new AudioContext();

  try {
    return await audioContext.decodeAudioData(audioArrayBuffer);
  } catch (error) {
    return null;
  } finally {
    await audioContext.close();
  }
};
